module.exports = __webpack_public_path__ + "static/media/manual-screen-7.365f0e68.png";